// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--zpy4g","title":"title--o4SvH","textRight":"textRight--oQR0O","tableBox":"tableBox--EprNP"};